import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useLang } from '../../language/LanguageProvider.jsx';
import { generateUrl } from '../../other/generate-url';
import { getSeriesInfo, getVodInfo } from '../../other/load-playlist';
import DB from '../../other/local-db';
import { getSeriesTmdbData } from '../../other/tmdb';
import { useModalClose } from '../../other/use-modal-close';
import { optimizeName } from '../../other/vod-series-name-optimizer';
import { useYoutubeErrorDetector } from '../../other/youtube-error-detector';
import Seasons from '../Series/Seasons';

const Container = styled.div`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  user-select: none;
  z-index: 1000;
`;

const BackdropContainer = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 1000;
  cursor: pointer;
`;

const Box = styled.div`
  position: absolute;
  width: 80vw;
  left: 10vw;
  margin-top: 2vh;
  background-color: #181818;
  border-radius: 0.8rem;
  box-shadow: rgb(0 0 0 / 75%) 0px 3px 10px;
  overflow: auto;
  transform: translateY(-50%);
  top: 50%;
  max-height: 90vh;
  overflow-y: auto;
  z-index: 1001;
  pointer-events: auto;
`;

const Header = styled.div`
  height: 40vh;
  max-height: 60vh;
  background-color: #000;
  box-sizing: inherit;
  overflow: hidden;
  background-color: var(--first-color);
  pointer-events: none;
  position: relative;
  z-index: 1;
`;

const ImgHovered = styled.div`
  height: 40vh;
  max-height: 60vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  border-radius: 0.5rem 0.5rem 0 0;
  position: relative;
  z-index: 0;
  line-height: calc(15vw * 1.5);
`;

const Body = styled.div`
  opacity: 1;
  transform: none;
  background-color: #181818;
  position: relative;
  padding: 1.2rem 2.5rem;
  overflow: hidden;
  color: white;
`;

const Image = styled.img`
  height: auto;
  position: absolute;
  top: 12vh;
  left: 2rem;
  height: 25vh;
  box-shadow: 0 0 2rem 0 rgb(136 152 170 / 15%);
`;

const RatingDiv = styled.div`
  color: #46d369;
  padding-right: 0.5rem;
`;

const DescriptionDiv = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 8; /* number of lines to show */
  -webkit-box-orient: vertical;
  cursor: pointer;
`;

const TitleInfo = styled.span`
  color: #777;
  margin-right: 0.2rem;
  display: inline-flex;
`;

const TitleData = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
`;

const ButtonMain = styled(Link)`
  color: black !important;
  -webkit-text-fill-color: black;
  -webkit-text-stroke-width: 0px;
  padding: 0.6rem 1.5rem;
  transition: all 0.3s ease;
`;

const ButtonFavorite = styled.button`
  color: black !important;
  -webkit-text-fill-color: black;
  -webkit-text-stroke-width: 0px;
  padding: 0.6rem 1.5rem;
  transition: all 0.3s ease;
`;

const ButtonSecond = styled.a`
  color: white !important;
  -webkit-text-fill-color: white;
  -webkit-text-stroke-width: 0px;
  padding: 0.6rem 1.5rem;
  transition: all 0.3s ease;
`;
const CloseBtn = styled.i`
  position: absolute;
  top: 1vh;
  right: 2rem;
  color: white;
  cursor: pointer;
  z-index: 100;
  font-size: x-large;
  text-align: right;
  z-index: 1000000;

  background-color: rgb(0 0 0 / 75%);
  border-radius: 50%;
  padding: 0.05rem;
`;

const MoreInfo = ({ style }) => {
  const { t } = useLang();
  const { category, stream_id, playingMode } = useParams();
  const history = useHistory();

  const stream = useSelector((state) => state.playlist).find((x) =>
    playingMode === 'series'
      ? parseInt(x.series_id) === parseInt(stream_id)
      : parseInt(x.stream_id) === parseInt(stream_id)
  );

  const [expandDescription, setExpandDescription] = useState(false);
  const [Name, setName] = useState(stream && optimizeName(stream.name));
  const [Description, setDescription] = useState('');
  const [ImageSrc, setImageSrc] = useState(stream && stream.stream_icon);
  const [Rating, setRating] = useState(false);
  const [youtubeId, setYoutubeId] = useState(null);
  const [backdropPath, setBackdropPath] = useState(null);
  const [Genres, setGenres] = useState('');
  const [Actor, setActor] = useState('');
  const [Year, setYear] = useState('');
  const [seasons, setSeasons] = useState({});
  const [favorite, setFavorite] = useState(null);
  const [url, setUrl] = useState();
  const iframeRef = useRef(null);

  const { status: youtubeStatus, registerIframe } =
    useYoutubeErrorDetector(youtubeId);

  useEffect(() => {
    setFavorite(!!DB.findOne(playingMode, stream_id, true));

    async function fetchData() {
      if (!stream) {
        history.replace(`/${playingMode}/`);
        return;
      }
      (playingMode === 'series'
        ? getSeriesInfo(stream.series_id, stream.name, false, stream.tmdb)
        : getVodInfo(stream.stream_id, stream.name, stream.tmdb)
      ).then(async (result) => {
        if (result && result.info) {
          let info = result.info;
          info.name && setName(info.name);
          info.description && setDescription(info.description);
          info.image && setImageSrc(info.image);
          info.cover && setImageSrc(info.cover);
          info.youtube_trailer && setYoutubeId(info.youtube_trailer);
          info.backdrop_path &&
            info.backdrop_path.length > 0 &&
            setBackdropPath(info.backdrop_path[0]);
          if (
            playingMode === 'series' &&
            typeof window !== 'undefined' &&
            window.tmdb
          ) {
            try {
              const tmdbData = await getSeriesTmdbData(
                stream.name,
                result.episodes,
                stream.tmdb
              );
              if (tmdbData && tmdbData.info && tmdbData.info.genre)
                setGenres(tmdbData.info.genre);
              else if (info.genre) setGenres(info.genre);
            } catch (_) {
              info.genre && setGenres(info.genre);
            }
          } else {
            info.genre && setGenres(info.genre);
          }
          info.actors && setActor(info.actors);
          info.releasedate && setYear(info.releasedate);

          if (info.rating) {
            const push = { full: [], empty: [], half: false };
            const quotient = Math.floor(info.rating / 2);
            const remainder = info.rating % 2 > 0 ? 1 : 0;
            for (let i = 0; i < quotient; i++) push.full.push(1);
            for (
              let i = 0;
              i < 5 - remainder - quotient + (quotient === 1 ? 0 : 1);
              i++
            )
              push.empty.push(1);
            push.half = quotient === 1;
            setRating({ ...push });
          }
          playingMode === 'series' && setSeasons(result.episodes);
        }
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (!stream) return;
    playingMode === 'movie' &&
      setUrl(
        generateUrl('movie', stream.stream_id, stream.container_extension)
      );
  }, [stream]);

  const setFavoriteGlob = (event) => {
    event.stopPropagation();
    if (!!favorite) DB.del(playingMode, stream_id, true);
    else DB.set(playingMode, stream_id, { id: stream_id }, true);
    setFavorite(!favorite);
  };

  const youtubeError = youtubeStatus === 'error';
  const shouldShowYoutube = youtubeId && !youtubeError;

  useEffect(() => {
    if (iframeRef.current) {
      registerIframe(iframeRef.current);
    }
  }, [registerIframe, youtubeId]);

  const boxRef = useRef(null);

  const handleClose = () => {
    history.goBack();
  };

  const handleBackdropClick = (event) => {
    if (boxRef.current && !boxRef.current.contains(event.target)) {
      handleClose();
    }
  };

  useModalClose(handleClose, true);

  return (
    <Container style={style}>
      <BackdropContainer onClick={handleBackdropClick} />
      <Box ref={boxRef}>
        {!window.gSTB && (
          <CloseBtn
            className="fas fa-times-circle"
            onClick={() => history.goBack()}></CloseBtn>
        )}
        {shouldShowYoutube ? (
          <Header>
            <iframe
              ref={iframeRef}
              frameBorder="0"
              height="100%"
              width="100%"
              title="youtube-pop"
              src={`https://youtube.com/embed/${youtubeId}?autoplay=1&controls=0&showinfo=0&autohide=1&mute=1&loop=1&disablekb=1&modestbranding=1&playlist=${youtubeId}&origin=${window.location.origin}`}
              allow="autoplay; encrypted-media"
              allowFullScreen
              style={{
                opacity: youtubeError ? 0 : 1,
                transition: 'opacity 0.5s ease',
              }}
            />
          </Header>
        ) : (
          <ImgHovered
            style={
              backdropPath || ImageSrc
                ? { backgroundImage: `url(${backdropPath || ImageSrc})` }
                : { display: 'none' }
            }
          />
        )}
        <Image src={ImageSrc} />
        <Body>
          <h1>{Name}</h1>
          <div className="row">
            <div className="col-8">
              <div style={{ display: 'flex' }}>
                {Rating && (
                  <RatingDiv>
                    {Rating.full.map((x, i) => (
                      <i key={'sf-' + i} className="fas fa-star"></i>
                    ))}
                    {Rating.half && <i className="fas fa-star-half"></i>}
                    {Rating.empty.map((x, i) => (
                      <i key={'s-' + i} className="far fa-star"></i>
                    ))}
                  </RatingDiv>
                )}
                <label>
                  <b>{Year}</b>
                </label>
              </div>
              <DescriptionDiv
                style={
                  expandDescription ? { '-webkit-line-clamp': 'unset' } : {}
                }
                onClick={() => setExpandDescription(!expandDescription)}>
                {Description}
              </DescriptionDiv>
            </div>
            <div className="col-4">
              {Actor && [
                <TitleInfo>{t('moreInfo.cast')} </TitleInfo>,
                <TitleData>{Actor}</TitleData>,
                <br />,
              ]}

              {Genres && [
                <TitleInfo>{t('moreInfo.genres')} </TitleInfo>,
                <TitleData>{Genres}</TitleData>,
                <br />,
              ]}

              {playingMode !== 'series' && (
                <ButtonMain
                  type="button"
                  className="btn btn-light btn-block mb-2 mt-1 btn-info-1"
                  data-id={1}
                  to={{
                    pathname: `/movie/category/${category}/${stream_id}/play/`,
                    search: window.location.search,
                  }}>
                  <i className="fas fa-play mr-1"></i>
                  {t('moreInfo.play')}
                </ButtonMain>
              )}
              <ButtonFavorite
                type="button"
                className="btn btn-warning btn-block mb-2 mt-1 btn-info-1"
                onClick={setFavoriteGlob}>
                <i
                  className={`${
                    favorite !== false ? 'fas fa-star' : 'far fa-star'
                  } mr-1`}></i>
                {favorite !== false
                  ? t('moreInfo.removeFavorites')
                  : t('moreInfo.addFavorites')}
              </ButtonFavorite>
              <div className="btn-group btn-block" role="group">
                {youtubeId && (
                  <ButtonSecond
                    type="button"
                    className="btn btn-block btn-info-2"
                    data-id={2}
                    style={{ backgroundColor: '#c4302b' }}
                    href={`https://www.youtube.com/watch?v=${youtubeId}`}
                    target="_blank">
                    <i className="fab fa-youtube mr-1"></i>
                    {t('moreInfo.trailer')}
                  </ButtonSecond>
                )}

                {url ? (
                  <ButtonSecond
                    type="button"
                    className={`btn btn-secondary btn-info-${
                      !youtubeId ? 2 : 3
                    }`}
                    data-id={!youtubeId ? 2 : 3}
                    href={url}
                    target="_blank">
                    <i
                      className={`fas fa-download ${!youtubeId && 'mr-1'}`}></i>
                    {!youtubeId && t('moreInfo.download')}
                  </ButtonSecond>
                ) : null}
              </div>
            </div>
          </div>
          {playingMode === 'series' && (
            <Seasons seasonData={seasons} cover={backdropPath || ImageSrc} />
          )}
        </Body>
      </Box>
    </Container>
  );
};

export default MoreInfo;
